export const toKebabCase = (text) => text.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`)
